import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { StyledModalWorkout } from "./styles";
import { RadioButton, RadioButtonWrapper } from "../RecogntionAdmin/styles";
import { AudioUploadBox } from "../JourneyChallenge/styles";
import { StyledInputV2, StyledLabel, InputContainer, Border } from "../CreateEvent/style";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { UploadIconSVG, CloseIconBranding, PromotionalDocIcon } from "../../utils/icons";
import { RemoveImageV2, UploadPhotoContainer } from "../common/CommonImageUploader/style";
import { uploadToS3, deleteFromS3, fetchApi } from "../../utils/methods";
import { UpdateAudioVideoTask } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";


const UploadAudioVideoModal = ({ show, onClose, onSave, weekIndex, dayIndex, initialData, libraryId, taskId }) => {
  const [selectedOption, setSelectedOption] = useState(0); // 0 = audio, 1 = video link
  const [audioLink, setAudioLink] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (show) {
      if (initialData?.media_type === "mp3") {
        setSelectedOption(0);
        setAudioLink(initialData?.media_link || "");
        setVideoLink("");
      } else if (initialData?.media_type === "mp4") {
        setSelectedOption(1);
        setVideoLink(initialData?.video_link || "");
        setAudioLink("");
      } else {
        setSelectedOption(0);
        setAudioLink("");
        setVideoLink("");
      }
    }
  }, [show, initialData]);

  const handleOptionChange = (val) => {
    setSelectedOption(val);
  };

  const handleAudioUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size / 1000000 > 10) return toast.error("Max 10MB");
    if (file.type !== "audio/mpeg") return toast.error("Only MP3 allowed");

    setUploading(true);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = async () => {
      try {
        const s3Url = await uploadToS3(reader.result, "wellness/challenges/media");
        if (s3Url?.path) {
          setAudioLink(s3Url.path);
        } else {
          toast.error("Upload failed");
        }
      } catch {
        toast.error("Something went wrong");
      } finally {
        setUploading(false);
      }
    };
  };

  const handleRemoveAudio = async () => {
    try {
      if (audioLink) await deleteFromS3(audioLink);
      setAudioLink("");
    } catch {
      toast.error("Failed to remove audio");
    }
  };

  const handleSave = async () => {
    const mediaType = selectedOption === 0 ? "mp3" : "mp4";
    const mediaLink = selectedOption === 0 ? audioLink : videoLink;

    setUploading(true);
    try {
      if (selectedOption === 1 && audioLink) {
        try { await deleteFromS3(audioLink); } catch { /* ignore S3 cleanup error */ }
      }
      const res = await fetchApi(UpdateAudioVideoTask, "POST", {
        task_id: taskId,
        library_id: libraryId,
        media_type: mediaType,
        media_link: mediaLink,
      });
      if (res?.success !== "success") {
        toast.error(res?.data?.message || "Failed to save media");
        setUploading(false);
        return;
      }
    } catch {
      toast.error("Something went wrong");
      setUploading(false);
      return;
    }
    setUploading(false);

    onSave(weekIndex, dayIndex, {
      media_type: mediaType,
      media_link: selectedOption === 0 ? mediaLink : "",
      video_link: selectedOption === 1 ? mediaLink : "",
    });
    onClose();
  };

  const isSaveDisabled = uploading || (selectedOption === 0 ? !audioLink : !videoLink.trim());
  const modalHeight = selectedOption === 0 ? "394px" : "280px";

  return (
    <StyledModalWorkout
      show={show}
      onHide={onClose}
      newWidth="800px"
      newHeight={modalHeight}
      centered
      isOverFlow={"hidden"}
    >
      <Modal.Header>
        <div className="modal-container">Upload Audio/Video</div>
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          {CloseIconBranding("#DA6C74", "14", "14")}
        </div>
      </Modal.Header>

      <Border style={{ background: "#EFEFEF", margin: "0px" }} />


      <Modal.Body>
        <div className="radioButtonDiv" style={{ marginBottom: "16px" }}>
          <RadioButtonWrapper isMargin="0px" width gap>
            <div className="RadioButtonContainer">
              <RadioButton
                type="radio"
                checked={selectedOption === 0}
                onChange={() => handleOptionChange(0)}
                value={0}
                id="modal-audio"
              />
              <div className="label">Upload audio</div>
            </div>
            <div className="RadioButtonContainer">
              <RadioButton
                type="radio"
                checked={selectedOption === 1}
                onChange={() => handleOptionChange(1)}
                value={1}
                id="modal-video"
              />
              <div className="label">Upload video link</div>
            </div>
          </RadioButtonWrapper>
        </div>

        {selectedOption === 0 ? (
          <>
            <StyledLabel isFont="14px" color="#184A61" margin="0px">
              Add Audio file
            </StyledLabel>
            {audioLink ? (
              <UploadPhotoContainer showBorder={false}>
                <div className="innerDivImageContainer">
                  <RemoveImageV2>
                    <div className="uploadImage">
                      <div className="promotional-doc">
                        <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                        <div>
                          <span className="promotional-doc-name">Audio uploaded successfully!</span>
                        </div>
                      </div>
                      <div className="main-div" onClick={handleRemoveAudio}>
                        <div className="icon-div">
                          <div className="sub-icon-div">{CloseIconBranding("#DA6C74", "8", "8")}</div>
                        </div>
                      </div>
                    </div>
                  </RemoveImageV2>
                </div>
              </UploadPhotoContainer>
            ) : (
              <AudioUploadBox>
                <div style={{ marginBottom: "8px" }}>
                  <UploadIconSVG />
                </div>
                <div style={{ color: "#184A61", fontWeight: "bold" }}>
                  {uploading ? "Uploading..." : "Upload Audio"}
                </div>
                <div style={{ color: "#666", fontSize: "12px" }}>(.mp3)</div>
                <input
                  type="file"
                  accept=".mp3,audio/mpeg"
                  onChange={handleAudioUpload}
                  disabled={uploading}
                />
              </AudioUploadBox>
            )}
          </>
        ) : (
          <InputContainer>
            <StyledLabel isFont="14px" color="#184A61" margin="0px">
              Video link
            </StyledLabel>
            <StyledInputV2
              placeholder="Enter link"
              value={videoLink}
              onChange={(e) => setVideoLink(e.target.value)}
              style={{ background: "white" }}
              pColor="#BDBDBD"
              color="#184A61"
              border="1px solid #BDBDBD"
            />
          </InputContainer>
        )}
      </Modal.Body>

      <Modal.Footer>
        <CommonButtonPopup
          height="40px"
          width="200px"
          disabled={isSaveDisabled}
          onClick={isSaveDisabled ? null : handleSave}
        >
          Save
        </CommonButtonPopup>
      </Modal.Footer>
    </StyledModalWorkout>
  );
};

UploadAudioVideoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  weekIndex: PropTypes.number,
  dayIndex: PropTypes.number,
  libraryId: PropTypes.number,
  taskId: PropTypes.number,
  initialData: PropTypes.shape({
    media_type: PropTypes.string,
    media_link: PropTypes.string,
    video_link: PropTypes.string,
  }),
};

export default UploadAudioVideoModal;
